'use client'

import React, { createContext, useContext, useState } from 'react'

interface DisplayCountContextType {
  totalDisplay: number
  setTotalDisplay: (count: number) => void
  setTotalDisplayShow: (count: number) => void
  totalDisplayShow: number
}

const DisplayCountContext = createContext<DisplayCountContextType | undefined>(undefined)

export const useDisplayCount = () => {
  const context = useContext(DisplayCountContext)
  if (!context) {
    throw new Error('useDisplayCount must be used within a DisplayCountProvider')
  }
  return context
}

export const DisplayCountProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [totalDisplay, setTotalDisplay] = useState(0)
  const [totalDisplayShow, setTotalDisplayShow] = useState(0)
  return (
    <DisplayCountContext.Provider value={{ totalDisplay, setTotalDisplay, totalDisplayShow, setTotalDisplayShow }}>
      {children}
    </DisplayCountContext.Provider>
  )
}
